module.exports = __webpack_public_path__ + "img/1.0937b498.jpg";